
import { useNavigate } from "react-router-dom"
export const CTAsection = () => {
    const navigate = useNavigate()
    return (

        <section className="min-h-screen flex flex-col items-center justify-center px-4 py-20 bg-white">

            <div className="max-w-3xl mx-auto text-center">
                <h2 className="font-serif text-4xl text-black md:text-5xl mb-6">
                    Ready to Get Started?
                </h2>
                <p className="text-gray-600 text-lg mb-8">
                    Create your SpellTree in minutes. No credit card required.
                </p>
                <div className=" max-w-md mx-auto">

                    <button className="bg-black text-white px-8 py-4 rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap" onClick={() => {
                        navigate("/signup")
                    }}>
                        Sign up free
                    </button>
                </div>
            </div>
        </section>
    )
}
